import usePartnerIframePostMessage from '@/composables/iframe/usePartnerIframePostMessage';
import useWebViewPostMessage from '@/composables/webview/useWebViewPostMessage';

/**
 * Single entry point for partner-facing notification events (loading, ready,
 * payment pending/complete, error). Fans each event out to every transport
 * that should receive it:
 *
 * - the browser iframe bridge (`usePartnerIframePostMessage`), for partners
 *   embedding the Buy button in an iframe (`embeddedButtonOnlyIframeMode`)
 * - the native WebView bridge (`useWebViewPostMessage`), for partners
 *   wrapping the SPA in a native iOS/Android WebView — mirrored whenever the
 *   iframe bridge actually sends a message
 *
 * `usePartnerIframePostMessage` and `useWebViewPostMessage` know nothing
 * about each other; this composable is the only place that wires them
 * together, via the iframe composable's `onNotify` hook. Adding, removing,
 * or changing a transport only touches this file.
 *
 * Exposes the same API as `usePartnerIframePostMessage`: notifyLoading,
 * notifyReady, notifyPaymentPending, notifyPaymentComplete, notifyError.
 */
export default function usePartnerNotifications() {
  const { dispatchWalletBridge } = useWebViewPostMessage();

  const mirrorToWebView = (payload) => {
    const { type, ...rest } = payload;
    dispatchWalletBridge(rest, type);
  };

  return usePartnerIframePostMessage(mirrorToWebView);
}
